import { getTvObject, tv } from '@costar-ui/cosmos';

var spinnerTV = getTvObject({
  base: 'animate-spin text-inherit',
  variants: {
    color: {
      'on-base': 'text-primary',
      'on-primary': 'text-on-primary',
      'on-primary-moderate': 'text-on-primary-moderate',
      'on-primary-contrast': 'text-on-primary-contrast',
      'on-primary-subtlest': 'text-on-primary-subtlest',
      'on-status-negative': 'text-on-status-negative',
      'on-status-caution': 'text-on-status-caution',
      'on-status-positive': 'text-on-status-positive',
      'on-neutral': 'text-on-neutral'
    },
    size: {
      fill: '',
      xs: ['w-3', 'h-3'],
      sm: ['w-5', 'h-5'],
      md: ['w-6', 'h-6'],
      lg: ['w-8', 'h-8'],
      xl: ['w-9', 'h-9'],
      xxl: ['w-10', 'h-10'],
      'xl-2': ['w-12', 'h-12']
    }
  }
});
var base = tv(spinnerTV);
var spinnerStyles = {
  base: base
};

export { spinnerStyles, spinnerTV };
//# sourceMappingURL=spinner.styles.esm.js.map
